import { isDefined } from "@clipboard-health/util-ts";
import { Pill } from "@src/appV2/redesign/system/ui-components";
import { addHours, isBefore, parseISO } from "date-fns";

import { formatDayOfMonth } from "../../utils/formatDayOfMonth";
import { type VisitWithCaseData } from "../types";

interface VisitStatusAlertPillProps {
  visit: VisitWithCaseData;
}

export function VisitStatusAlertPill(props: VisitStatusAlertPillProps): JSX.Element | null {
  const { visit } = props;
  const { attributes } = visit ?? {};
  const { status, confirmedVisitDate, pendedAt, bookedAt } = attributes ?? {};

  if (status === "FILLED" && isDefined(bookedAt)) {
    // @ts-expect-error - bookedAt is a string
    const parsedBookedAt = parseISO(bookedAt);
    const confirmationDeadline = addHours(parsedBookedAt, 24);

    if (isBefore(confirmationDeadline, new Date())) {
      return null;
    }

    return (
      <Pill
        label="Confirm/Pend now to avoid penalty"
        backgroundColor={(theme) => theme.palette.intent?.warning?.background}
        color={(theme) => theme.palette.intent?.warning?.text}
      />
    );
  }

  if (status === "PENDING" && isDefined(pendedAt)) {
    // @ts-expect-error - pendedAt is a string
    const parsedPendedAt = parseISO(pendedAt);
    const formattedDate = formatDayOfMonth(parsedPendedAt);

    return (
      <Pill
        label={`Visit marked pending on ${formattedDate}`}
        backgroundColor={(theme) => theme.palette.intent?.neutral?.background}
        color={(theme) => theme.palette.intent?.neutral?.text}
      />
    );
  }

  if (status === "CONFIRMED" && isDefined(confirmedVisitDate)) {
    // @ts-expect-error - confirmedVisitDate is a string
    const parsedConfirmedVisitDate = parseISO(confirmedVisitDate);
    const formattedDate = formatDayOfMonth(parsedConfirmedVisitDate);

    if (isBefore(parsedConfirmedVisitDate, new Date())) {
      return (
        <Pill
          label="Log or Update by today"
          backgroundColor={(theme) => theme.palette.intent?.warning?.background}
          color={(theme) => theme.palette.intent?.warning?.text}
        />
      );
    }

    return (
      <Pill
        label={`Visit confirmed for ${formattedDate}`}
        backgroundColor={(theme) => theme.palette.intent?.success?.background}
        color={(theme) => theme.palette.intent?.success?.text}
      />
    );
  }

  return null;
}
